import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const logo = `${process.env.PUBLIC_URL}/logo-original.png`;

const SUPPORT_EMAIL = 'support@zivugmishamayim.com';
const MAILTO_SUPPORT = `mailto:${SUPPORT_EMAIL}?subject=Zivug%20Mishamayim%20support%20request`;

const CHILD_SAFETY_EMAIL = 'hello@zivugmishamayim.com';
const MAILTO_CHILD_SAFETY = `mailto:${CHILD_SAFETY_EMAIL}?subject=Child%20safety%20report%20or%20inquiry`;

function SupportPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App legal-page">
      <nav className="navbar">
        <div className="container">
          <div className="nav-content">
            <div className="logo">
              <Link to="/" aria-label="Zivug Mishamayim home">
                <img src={logo} alt="Zivug Mishamayim" className="logo-image" />
              </Link>
            </div>
            <div className="nav-links">
              <Link to="/">Home</Link>
              <Link to="/donate">Donate</Link>
            </div>
          </div>
        </div>
      </nav>

      <main className="legal-document">
        <div className="container">
          <article className="legal-document-inner">
            <h1>Help &amp; Support</h1>
            <p className="legal-meta">
              We're here to help with the Zivug Mishamayim app and your account.
            </p>

            <h2>Contact us</h2>
            <p>
              <strong>Email:</strong>{' '}
              <a href={MAILTO_SUPPORT}>{SUPPORT_EMAIL}</a>
            </p>
            <p>
              <strong>Mailing address:</strong>
              <br />
              Zivug Mishamayim
              <br />
              561 East 3rd Street
              <br />
              Brooklyn, NY 11218
              <br />
              United States
            </p>
            <p>
              We answer most messages within <strong>1-2 business days</strong> (U.S. Eastern time). If your issue is
              urgent or safety-related, please say so in the subject line.
            </p>

            <h2>Child Safety Standards</h2>
            <p>
              Zivug Mishamayim is committed to providing a safe environment for all users. We maintain a zero-tolerance
              policy regarding any content or behavior that harms or exploits minors.
            </p>

            <h3>Explicit prohibition of CSAE</h3>
            <p>
              Zivug Mishamayim strictly prohibits the creation, sharing, promotion, or distribution of Child Sexual Abuse
              Material (CSAM) and Child Sexual Abuse and Exploitation (CSAE). Any account found engaging in,
              facilitating, or advocating for CSAE will be permanently banned immediately, and we will report the
              activity to the National Center for Missing &amp; Exploited Children (NCMEC) and relevant law enforcement
              authorities.
            </p>

            <h3>Reporting mechanism</h3>
            <p>
              If you encounter any content or behavior on our platform that violates these child safety standards,
              please report it immediately using our in-app reporting tools or by contacting our dedicated child
              safety point of contact.
            </p>

            <h3>Dedicated point of contact</h3>
            <p>
              For any compliance inquiries, reports, or questions regarding our child safety standards, please reach out
              to our designated team at{' '}
              <a href={MAILTO_CHILD_SAFETY}>{CHILD_SAFETY_EMAIL}</a>.
            </p>

            <h2>Before you write</h2>
            <p>
              Including a few details helps us resolve your request faster. If you can, mention:
            </p>
            <ul>
              <li>Device (for example iPhone 15 or Samsung Galaxy)</li>
              <li>Operating system version</li>
              <li>App version (from your profile or app settings, if shown)</li>
              <li>What you were trying to do and what happened instead</li>
            </ul>

            <h2>Common topics</h2>
            <h3>Sign-in or account access</h3>
            <p>
              Use the password reset option in the app if you forgot your password. If you no longer have access to your
              email, contact us from an address we can verify or explain the situation in your message.
            </p>
            <h3>Profiles and shared links</h3>
            <p>
              Profile links open in the app when it is installed. If a link does not open as expected, confirm the app is
              up to date and try again from your device's browser.
            </p>
            <h3>Push notifications</h3>
            <p>
              Notifications can be turned on or off in your device settings. If alerts stopped working, check that
              notifications are allowed for Zivug Mishamayim and that battery-saving modes are not restricting the app.
            </p>
            <h3>Privacy and your data</h3>
            <p>
              For how we handle personal information, see our{' '}
              <Link to="/privacy">Privacy Policy</Link>. For privacy-specific requests (access, correction, deletion),
              email us at the address above.
            </p>

            <h2>Get the app</h2>
            <p>
              Download links and feature overview are on our{' '}
              <Link to="/">home page</Link>.
            </p>
          </article>
        </div>
      </main>

      <footer className="footer legal-footer">
        <div className="container">
          <div className="footer-bottom">
            <p>
              <Link to="/">← Back to home</Link>
              {' · '}
              <Link to="/privacy">Privacy Policy</Link>
              {' · '}
              <a href={MAILTO_SUPPORT}>Email support</a>
            </p>
            <p>&copy; 2026 Zivug Mishamayim. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default SupportPage;
